import { render, staticRenderFns } from "./OrdersBottomLeft.vue?vue&type=template&id=4562424e&scoped=true&"
import script from "./OrdersBottomLeft.vue?vue&type=script&lang=js&"
export * from "./OrdersBottomLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4562424e",
  null
  
)

export default component.exports